import { render, staticRenderFns } from "./pageContent.vue?vue&type=template&id=2c0f2578&scoped=true"
import script from "./pageContent.vue?vue&type=script&lang=js"
export * from "./pageContent.vue?vue&type=script&lang=js"
import style0 from "./pageContent.vue?vue&type=style&index=0&id=2c0f2578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f2578",
  null
  
)

export default component.exports